import { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useApp } from "../../../context/AppContext";

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function Sidebar() {

    //get context
    const { token } = useApp();

    //get navigate
    const navigate = useNavigate();

    //get locale
    const { t } = useTranslation();
    const { locale } = useParams();

    useEffect(()=> {
        if(!token) {
            navigate(`/${locale}`)
        }
    }, [token])

    return (
        <div className="border bordar-gray-200 rounded-xl p-5">
            <div className="pb-3 border-b upper font-bold text-lg">{t('menu')}</div>
            <div className="py-3 border-b flex items-center justify-between">
                <Link to={`/${locale}/profile`}>{t('profile')}</Link>
            </div>
            <div className="py-3 border-b flex items-center justify-between">
                <Link to={`/${locale}/orders`}>{t('my_orders')}</Link>
            </div>
            <div className="pt-3 flex items-center justify-between">
                <Link to={`/${locale}/transactions`}>{t('transactions')}</Link>
            </div>
        </div>
        
    );
}